<template>
  <div class="auth-form-field" v-if="fieldAttribute">
    <email
      v-if="fieldAttribute.type === 'email'"
      :field="fieldAttribute"
      @setAttribute="emitAttribute"
    />
    <password
      v-else-if="fieldAttribute.type === 'password'"
      :field="fieldAttribute"
      @setAttribute="emitAttribute"
    />
    <radio-select-field
      v-else-if="fieldAttribute.type === 'radioselect'"
      :select="fieldAttribute"
      @setSelect="emitAttribute"
    />
    <date-field
      v-else-if="fieldAttribute.type === 'date'"
      :field="fieldAttribute"
      @input="emitAttribute"
    />
    <switch-field
      v-else-if="fieldAttribute.type === 'bool'"
      :field="fieldAttribute"
      :bool-has-defined-title="boolHasDefinedTitle"
      @switch="emitAttribute"
    />
    <select-field
      v-else-if="
        fieldAttribute.type === 'select' || fieldAttribute.type === 'interests'
      "
      :field="fieldAttribute"
      :multiple="fieldAttribute.type === 'interests'"
      @select="emitAttribute"
    />
    <location-field
      v-else-if="fieldAttribute.type === 'location'"
      :field="fieldAttribute"
      @select="emitAttribute"
    />
    <country-field
      v-else-if="fieldAttribute.key === 'country'"
      :field="fieldAttribute"
      :custom-props="customProps"
      @input="emitAttribute"
    />
    <terms-and-privacy-field
      v-else-if="fieldAttribute.key === 'terms_and_privacy'"
      :field="fieldAttribute"
      :selected-country="selectedCountry"
      @select="emitAttribute"
    />
    <text-field v-else :field="fieldAttribute" @setText="emitAttribute" />
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import {
  runtimeConditionsAreMet,
  getFieldCustomRegexValidation
} from "@/utils/auth/validation";
import Email from "./fields/Email";
import Password from "./fields/Password";
import TextField from "./fields/TextField";
import SelectField from "./fields/SelectField";
import RadioSelectField from "./fields/RadioSelectField";
import DateField from "./fields/DateField";
import SwitchField from "./fields/SwitchField";
import LocationField from "./fields/LocationField";
import CountryField from "./fields/CountryField";
import TermsAndPrivacyField from "./fields/TermsAndPrivacyField";

export default {
  components: {
    Email,
    Password,
    TextField,
    SelectField,
    RadioSelectField,
    SwitchField,
    DateField,
    LocationField,
    CountryField,
    TermsAndPrivacyField
  },
  props: {
    attribute: {
      type: Object,
      required: true
    },
    boolHasDefinedTitle: {
      type: Boolean,
      default: false
    },
    customProps: {
      type: Object,
      default: () => {}
    },
    selectedCountry: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["authSettings"]),
    customLabel() {
      if (this.customProps) {
        return _.get(this.customProps, "label", "");
      }

      return "";
    },
    required() {
      if (
        _.has(this.authSettings, [
          "attributes",
          this.attribute.key,
          "required_conditions"
        ])
      ) {
        const conditions = _.get(
          this.authSettings,
          ["attributes", this.attribute.key, "required_conditions"],
          []
        );

        return runtimeConditionsAreMet(this.$parent.fullFormData, conditions);
      }

      return this.attribute.required;
    },
    fieldAttribute() {
      const attribute = {
        ...this.attribute,
        required: this.required,
        regexValidation: getFieldCustomRegexValidation(
          this.attribute.validators
        )
      };

      if (this.customLabel) {
        return {
          ...attribute,
          placeholder: this.customLabel
        };
      }

      return attribute;
    }
  },
  methods: {
    emitAttribute(attr) {
      this.$emit("setAttribute", attr);
    }
  }
};
</script>

<style lang="scss" scoped>
.auth-form-field {
  margin-top: 5px;

  ::v-deep .row {
    margin-right: 0;
    margin-left: 0;
  }
}
</style>
